<template>
  <campsite-breadcrumbs
    v-show="hierarchyBreadcrumbs.length"
    :categories="[]"
    :hierarchy-breadcrumbs="hierarchyBreadcrumbs || []"
    :with-counts="false"
    class="campsite-breadcrumbs"
    data-test="campsite-details-breadcrumbs"
  >
    <template #flag>
      <pu-flag
        :lazy="false"
        :country-iso="countryIso"
        class="flag"
        alt=""
        width="25"
        height="12"
      />
    </template>
  </campsite-breadcrumbs>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import CampsiteBreadcrumbs from '../../../components/breadcrumbs/CampsiteBreadcrumbs.vue'
import { HierarchyPart } from '../../pu-links/breadcrumbs/hierarchy-breadcrumbs'

@Component({
  components: {
    CampsiteBreadcrumbs,
  },
})
class CampsiteDetailSearchBreadcrumbs extends Vue {
  @Prop({ required: true })
  hierarchyBreadcrumbs: HierarchyPart[]

  @Prop({ required: true })
  countryIso: string
}

export default toNative(CampsiteDetailSearchBreadcrumbs)
</script>
